<template>
  <div class="layout gap-7" :class="{ reverse, end }">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  reverse?: boolean;
  end?: boolean;
}>();
</script>

<style scoped lang="scss">
.layout {
  display: grid;
  grid-template-columns: minmax(0, 360px) calc(2 * (100% / 3));
}
.reverse {
  grid-template-columns: calc(2 * (100% / 3)) minmax(0, 360px);
}
.end {
  grid-template-columns: minmax(0, 360px) 1fr;
}

@media (max-width: 850px) { 
  .layout {
    display: flex;
    flex-direction: column;
    gap: var(--space-6) !important;
  }
}
</style>